import SolicitationsSearchBar from './SolicitationsSearchBar';

export default SolicitationsSearchBar;



// WEBPACK FOOTER //
// ./src/components/SolicitationsSearchBar/index.jsx